import { StateCreator } from "zustand";
import { playAlertSound } from "@/lib/audio";

export interface DroneDetails {
  altitude?: number;
  speed?: number;
  heading?: number;
  [key: string]: unknown;
}

export interface Detection {
  id: string;
  sensor_id: string;
  detection_time: string;
  latitude: number;
  longitude: number;
  drone_identifier: string;
  drone_details: DroneDetails | string;
  received_at: string;
  h3_index: string;
}

export interface DetectionSlice {
  trackedDroneId: string | null;
  trackedDrone: Detection | null;
  detections: Detection[];
  drones: Set<string>;
  alertsEnabled: boolean;
  setTrackedDroneId: (id: string | null) => void;
  addDrone: (id: string) => void;
  addDetection: (d: Detection) => void;
  reset: () => void;
  toggleAlerts: () => void;
}

export const createDetectionSlice: StateCreator<DetectionSlice> = (
  set,
  get
) => ({
  detections: [],
  drones: new Set<string>(),
  trackedDroneId: "",
  trackedDrone: null,
  alertsEnabled: true,
  setTrackedDroneId: (id) => {
    set(() => ({ trackedDroneId: id }));
  },
  addDrone: (id) => {
    set((state) => ({ drones: state.drones.add(id) }));
  },
  addDetection: (d) => {
    const state = get();
    // Play alert sound if alerts are enabled and it's a new drone
    if (state.alertsEnabled && !state.drones.has(d.drone_identifier)) {
      playAlertSound();
    }
    set((state) => ({
      detections: [...state.detections, d],
      trackedDrone:
        d.drone_identifier === state.trackedDroneId ? d : state.trackedDrone,
    }));
  },
  reset: () => {
    set(() => ({
      detections: [],
      drones: new Set<string>(),
      trackedDrone: null,
    }));
  },
  toggleAlerts: () => {
    set((state) => ({ alertsEnabled: !state.alertsEnabled }));
  },
});
